<template>
  <el-alert
    v-if="isStale"
    title="Datos de producción desactualizados"
    type="warning"
    effect="dark"
    show-icon
    :closable="false"
    class="stale-banner"
  >
    <template #default>
      {{ mensaje }}
    </template>
  </el-alert>
</template>

<script setup>
defineProps({
  isStale: {
    type: Boolean,
    default: false,
  },
  mensaje: {
    type: String,
    default: 'Los datos de producción están desactualizados. Presione "Cotizar" para recalcular.',
  },
});
</script>

<style scoped>
.stale-banner {
  margin-bottom: 16px;
}
</style>
